import { TFunction } from 'i18next';
import { z } from 'zod';

const schema = (t: TFunction): z.Schema => {
  const emailLabel = t('global.email');

  return z.object({
    email: z
      .string()
      .min(
        3,
        t('validation.required', {
          field: emailLabel,
        }),
      )
      .email(
        t('validation.invalid', {
          field: emailLabel,
        }).trim(),
      ),
  });
};

export default schema;
